/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Linux_3Inputs */

const en_pc_dl_linux_3 = /** @type {(inputs: Pc_Dl_Linux_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedora, RHEL or openSUSE: sudo dnf install ./pdfcraft-*.rpm`)
};

const zh_pc_dl_linux_3 = /** @type {(inputs: Pc_Dl_Linux_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedora、RHEL 或 openSUSE：sudo dnf install ./pdfcraft-*.rpm`)
};

/**
* | output |
* | --- |
* | "Fedora, RHEL or openSUSE: sudo dnf install ./pdfcraft-*.rpm" |
*
* @param {Pc_Dl_Linux_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_linux_3 = /** @type {((inputs?: Pc_Dl_Linux_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Linux_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_linux_3(inputs)
	return zh_pc_dl_linux_3(inputs)
});
export { pc_dl_linux_3 as "pc.dl.linux.3" }